import { axiosReq } from "utils";
import { ChallengeTradesActions } from "./ChallengeTradesReducer";

export const getOpenTrades = (getToken, id) => {
  return async (dispatch) => {
    try {
      const token = await getToken();

      dispatch(ChallengeTradesActions.getOpenTradesRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/position/${id}`,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(ChallengeTradesActions.getOpenTradesSuccess(response?.data));
    } catch (error) {
      dispatch(
        ChallengeTradesActions.getOpenTradesError(
          error.response?.data.message || error?.message
        )
      );
    }
  };
};

export const getClosedTrades = (getToken, id) => {
  return async (dispatch) => {
    try {
      const token = await getToken();

      dispatch(ChallengeTradesActions.getClosedTradesRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/account/closedTrades/${id}`,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(ChallengeTradesActions.getClosedTradesSuccess(response?.data));
    } catch (error) {
      dispatch(
        ChallengeTradesActions.getClosedTradesError(
          error.response?.data.message || error?.message
        )
      );
    }
  };
};
